import {
  DataGrid,
  DataGridActions,
  DataGridColumns,
  DataGridSections,
  DataGridSelectedActions,
} from '@components/DataGrid/DataGrid'
import { useNavigate } from 'react-router-dom'
import { RoutePaths } from '@interfaces/routePaths'
import { Anchor, Button } from '@mantine/core'
import { randomArrayItem } from '@utils/randomArrayItem'
import { DataGridPerson } from '@components/DataGrid/DataGridPerson'
import ExampleLocation from '@assets/exampleLocation.png'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import { setActiveSection } from '@redux/site/siteSlice'

const MOCK_DATA = Array(30)
  .fill(0)
  .map((_, i) => {
    const placeName = randomArrayItem([
      'Achievement First Park Slope',
      'Achievement First Downtown',
      'Achievement First Williamsburg',
    ]) as string

    const getShortName = () => {
      switch (placeName) {
        case 'Achievement First Park Slope':
          return 'AFPS'
        case 'Achievement First Downtown':
          return 'AFD'
        case 'Achievement First Williamsburg':
          return 'AFW'
      }
    }
    return {
      id: `location-list-${i}`,
      placeName,
      shortName: getShortName(),
      number: (
        <Anchor href="tel:+1 (212) 555-1212" c="dark">
          +1 (212) 555-1212
        </Anchor>
      ),
      email: (
        <Anchor href="mailto:info@example.com" c="dark">
          info@example.com
        </Anchor>
      ),
      website: (
        <Anchor target="_blank" href="organization.com" c="dark">
          organization.com
        </Anchor>
      ),
      lastUpdated: randomArrayItem(['Today', '6w 3d', '2mo 21d']),
    }
  })

export const LocationList = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Locations'))
  })

  const handleNavigate = () =>
    navigate(`../${RoutePaths.RECORD}/123/${RoutePaths.RECORD_HOME}`, {
      state: {
        history: [
          {
            title: 'Community',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
          {
            title: 'Members',
            href: `${RoutePaths.COMMUNITY}/${RoutePaths.COMMUNITY_MEMBERS}`,
          },
        ],
      },
    })

  const columns: DataGridColumns[] = [
    {
      label: 'Name',
      prop: 'name',
      defaultSort: true,
      pinned: true,
    },
    {
      label: 'Short name',
      prop: 'shortName',
    },
    {
      label: 'Main number',
      prop: 'number',
    },
    {
      label: 'Email',
      prop: 'email',
    },
    {
      label: 'Website',
      prop: 'website',
    },
    {
      label: 'Last updated',
      prop: 'lastUpdated',
    },
  ]

  const sections: DataGridSections[] = [
    {
      label: 'All Locations',
      href: '#',
      default: true,
    },
    {
      label: 'Active Locations',
      href: '#',
    },
    {
      label: 'Inactive Locations',
      href: '#',
    },
  ]

  const actions: DataGridActions[] = [
    {
      label: 'Edit location profile',
      onClick: (item: any) =>
        navigate(
          `${RoutePaths.ADMIN_SETTINGS}/${RoutePaths.ADMIN_SETTINGS_LOCATION}/${RoutePaths.ADMIN_SETTINGS_LOCATION_PUBLIC_PROFILE}`,
        ),
    },
    {
      label: 'Deactive location',
      color: 'red',
      onClick: (item: any) => console.log('Action'),
    },
  ]

  const selectedActions: DataGridSelectedActions[] = [
    {
      label: 'Delete locations',
      color: 'red',
      variant: 'outline',
      onClick: (items: any) => console.log('Selected Actions: Edit'),
    },
  ]

  const data = MOCK_DATA.map((curr, i) => {
    return {
      ...curr,
      name: (
        <DataGridPerson
          name={curr.placeName}
          image={ExampleLocation}
          onClick={handleNavigate}
        />
      ),
      shortName: curr.shortName,
    }
  })

  return (
    <DataGrid
      data={data}
      columns={columns}
      sections={sections}
      actions={actions}
      results={data.length}
      buttons={<Button>Create Location</Button>}
      selectedActions={selectedActions}
      page={1}
    />
  )
}
